import { resolveElevenLabsProviderEnabled } from "@repo/common";
import { db } from "@repo/ui";
import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import type { Company } from "../types";

export function useElevenLabsProviderFlag(
	companyId?: string | null,
	company?: Company | null,
) {
	const [state, setState] = useState<{
		companyId: string;
		settings: Parameters<typeof resolveElevenLabsProviderEnabled>[0];
	} | null>(null);
	useEffect(() => {
		if (!companyId) return;
		return onSnapshot(
			doc(db, "settings", "system"),
			(snapshot) => {
				setState({
					companyId,
					settings: snapshot.exists() ? snapshot.data() : null,
				});
			},
			(error) => {
				console.error("Failed to load ElevenLabs provider feature flag", error);
				setState(null);
			},
		);
	}, [companyId]);
	// Never use another company's loaded value while a subscription is changing.
	return (
		!!companyId &&
		company?.id === companyId &&
		state?.companyId === companyId &&
		resolveElevenLabsProviderEnabled(state.settings, company)
	);
}
